import React from 'react';
import './Subscribe.css';
import BannerImage from '../../assets/utilities/Substack Banner.svg';

export const SubscribeSectionEmbedded = ({ showExtraContent = true }) => {
  return (
    <section
      className={`${showExtraContent ? 'subscribe-iframe-wrapper' : 'subscribe-iframe-wrapper-small'}`}
    >
      {showExtraContent ? (
        <>
          <p className="header-2">Subscribe to our Newsletter, it's Free!</p>
          <img src={BannerImage} alt="Subscribe" className="subscribe-banner" />
        </>
      ) : null}
      <iframe
        src="https://shippingsignals.substack.com/embed"
        title="Shipping Signals Newsletter"
        frameBorder="0"
        className={` ${showExtraContent ? 'subscribe-iframe' : 'subscribe-iframe-small'}`}
      ></iframe>
    </section>
  );
};

const SubscribeSection = () => {
  return <SubscribeSectionEmbedded />;
};

export default SubscribeSection;
